import businessDocumentItemVM from "../../BusinessDocuments/BusinessDocumentItemSelector/businessDocumentItemVM";
import businessDocumentVM from "../../BusinessDocuments/BusinessDocumentSelector/businessDocumentVM";

export interface ViewModel {
  customerRepName: string;
  customerRepEMail: string;
  customerRepPhone: string;
  salesDocument: businessDocumentVM | null;
  complaintItems: ComplaintItemViewModel[];
  attachments: AttachmentViewModel[];
}

export interface ComplaintServerVM {
  customerRepName: string;
  customerRepEMail: string;
  customerRepPhone: string;
  salesDocumentNumber: string;
  complaintDocumentTypeId: number | null;
  salesDate: Date | null;
  complaintItemVMs: ServerComplaintItemVM[];
  complaintAttachmentVMs: ServerAttachmentVM[];
}

export function complaintViewModelToServerModel(
  vm: ViewModel
): ComplaintServerVM {
  const r: ComplaintServerVM = {
    customerRepName: vm.customerRepName,
    customerRepEMail: vm.customerRepEMail,
    customerRepPhone: vm.customerRepPhone,
    salesDocumentNumber: vm.salesDocument?.documentNumber!,
    complaintDocumentTypeId: vm.salesDocument?.businessDocumentType!,
    salesDate: vm.salesDocument?.salesDateAsDateOnly!,
    complaintItemVMs: vm.complaintItems.map((x) =>
      complaintItemViewModelToServerModel(x)
    ),
    complaintAttachmentVMs: vm.attachments.map((x) =>
      attachmentViewModelToServerModel(x)
    ),
  };

  return r;
}

export interface AttachmentViewModel {
  id: string;
  originalFileName: string;
  name: string;
}

export interface ComplaintItemViewModel {
  /** Unique identifier for the product return request item used only on the client side, to track it during the editing process */
  id: string;
  documentItem: businessDocumentItemVM | null;
  amount: number | null;
  complaintTypeId: number | null;
  comments: string | null;
}

/** The client and server VMs are  different */
type ServerComplaintItemVM = {
  lineCode: string | null;
  productName: string | null;
  catalogNumber: string | null;
  amount: number | null;
  complaintTypeId: number | null;
  comments: string | null;
};

function complaintItemViewModelToServerModel(
  item: ComplaintItemViewModel
): ServerComplaintItemVM {
  return {
    lineCode: item.documentItem?.lineCode!,
    productName: item.documentItem?.productName!,
    catalogNumber: item.documentItem?.catalogNumber!,
    amount: item.amount,
    complaintTypeId: item.complaintTypeId,
    comments: item.comments
  }
}

export interface ServerAttachmentVM {
  attachmentId: string;
  originalFileName: string;
  attachmentName: string;
}

function attachmentViewModelToServerModel(
  avm: AttachmentViewModel
): ServerAttachmentVM {
  const r: ServerAttachmentVM = {
    attachmentId: avm.id,
    originalFileName: avm.originalFileName,
    attachmentName: avm.name,
  };

  return r;
}
